module.exports = __webpack_public_path__ + "assets/img/11_449_big.1ef9ca21.jpg";